import React from 'react';
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { Box, Paper, Skeleton, Typography } from '@mui/material';
import { formatMoney } from '../../../utils/currency';

const CustomTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;

  const item = payload[0]?.payload;

  return (
    <Box p={1} bgcolor="white" boxShadow={2} borderRadius={1}>
      <Typography variant="subtitle2">Dia {item.display}</Typography>
      <Typography variant="body2" fontWeight="bold">
        Ventas: {formatMoney(Number(item.value || 0))}
      </Typography>
      <Typography variant="body2">
        Tickets: {Number(item.ticketCount || 0).toLocaleString()}
      </Typography>
    </Box>
  );
};

const B2BDailyTrendChart = ({
  data = [],
  loading,
  title,
  color = '#ff7043',
  hasSummaryData = false,
}) => (
  <Paper elevation={2} sx={{ p: 2, height: 360 }}>
    <Typography variant="subtitle1" gutterBottom>
      {title}
    </Typography>
    <Box sx={{ width: '100%', height: 300 }}>
      {loading ? (
        <Skeleton variant="rectangular" width="100%" height={300} />
      ) : data.length > 0 ? (
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 20, right: 20, bottom: 0, left: 0 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="display" />
            <YAxis />
            <Tooltip content={<CustomTooltip />} />
            <Bar dataKey="value" fill={color} radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography variant="body2" color="textSecondary">
            {hasSummaryData ? 'No se recibió el desglose diario.' : 'No hay datos disponibles.'}
          </Typography>
        </Box>
      )}
    </Box>
  </Paper>
);

export default B2BDailyTrendChart;
